import "./mobileNav";

if (document.getElementById("new-product-table") !== null) {
  import("./productListings").then((script) => script.render());
}

if (document.getElementById("map") !== null) {
  import("./locationSearchMap").then((script) => script.render());
}

if (document.querySelector(".umbraco-forms-form") !== null) {
  import("./forms").then((script) => script.render());
}

if (document.querySelector("[data-tabs]") !== null) {
  import("./tabs").then((script) => script.render());
}

if (document.querySelector(".modal") !== null) {
  import("./modals").then((script) => script.render());
}

if (document.querySelector(".in-page-links") != null) {
  import("./inPageLinks").then((script) => script.render());
}

if (document.querySelector(".loading-button, .onunload-loading-button") != null) {
  import("./loadingSpinners").then((script) => script.render());
}

import "./analytics";

if (document.getElementById("chatTemplate") !== null) {
  const localOrIpAddress = new RegExp(/localhost|[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}|::1|\.local|^$/gi);
  const isLocalOrIpAddress = localOrIpAddress.test(window.location.hostname);

  if (window.location.hostname !== "" && !isLocalOrIpAddress) {
    import("./webChat").then((script) => {
      script.render();
      // script.open();
    });
  }
}

//Accordion
// Fetch all the details element.
const details = document.querySelectorAll("details");

// Add the onclick listeners.
details.forEach((detail) => {
  detail.addEventListener("toggle", () => {
    if (detail.open) setTargetDetail(detail);
  });
});

// Close all the details that are not targetDetail.
// This functionality is to make accordion to open only 1 accordion per click
/*function setTargetDetail(targetDetail) {
  details.forEach((detail) => {
    if (detail !== targetDetail) {
      detail.open = false;
    }
  });
} */

if(window.autoCompleteConfig){
  $("#query").autocomplete({
    source: window.autoCompleteConfig.source,
    minLength: 3,
    delay: 300,
    autoFocus: window.autoCompleteConfig.autoFocus,
    select: function (event, ui) {

        event.preventDefault();

        this.value = ui.item.label;
        window.location = ui.item.value;

    },
    focus: function (event, ui) {
        event.preventDefault();
    }
});
}

// Adds .row-content to social-share div if previous element has it
const socialShareElems = document.querySelectorAll(".social-share-section");
if(socialShareElems){
  socialShareElems.forEach(elem=>{    
    const hasRowContentClass = elem.previousElementSibling?.classList?.contains("row-content");
    if(hasRowContentClass){
      elem.classList.add("row-content");
    }
  });
}

// Header carousel
const swipers = document.querySelectorAll(".swiper");
if(swipers){
  swipers.forEach(elem=>{
    const autoSlideTime = parseInt(elem.dataset.autoSlideTime) * 1000;
    const enableAutoPlay = autoSlideTime > 0;
    
    const swiper = new Swiper(elem, {
      loop: enableAutoPlay,
      autoplay: enableAutoPlay ? {
        delay: autoSlideTime,
        disableOnInteraction: false
      } : false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'custom',
        renderCustom: function(swiper, current, total){
          var currentSlide = swiper.slides[current - 1];
          var isFullWidth = currentSlide.classList.contains("js-full-image");
          var html = `<div class="swiper-pagination-wrapper ${isFullWidth ? 'with-bg' : ''}">`;
          for(var i = 1; i<= total;i++){
              html+=   `<span class="swiper-pagination-bullet ${i == current ? 'swiper-pagination-bullet-active' : ''}" tabindex="0" role="button" aria-label="Go to slide ${i}" aria-current="${i == current ? "true" : "false"}"></span>`;        
          }
          html+='</div>';
          return html;
       }
      }
    });
  })
  
}


// Footer accordion
const footerNavAccordion = document.querySelectorAll("footer .mobile-accordion")
if(footerNavAccordion){
  footerNavAccordion.forEach(accordion=>{
    accordion.querySelectorAll(".accordion-heading")?.forEach(heading=>{
      const parent = heading.parentElement;
      heading.addEventListener("click", function(){
        if(heading.parentElement?.classList.contains("open")){
          parent?.classList.remove("open");
        }
        else{
          parent?.classList.add("open");
        }
      });
    });
  });
}

//quick Exit Button
var quickExitButton = document.getElementById("quick-exit-button-wrapper")
if (quickExitButton !== null) {
  quickExitButton.onclick = () => window.location.replace('https://google.com');
}


//sticky Banner Module  

$(function() {
  var banner = $(".sticky-bar");
  banner.hide();
  $(window).scroll(function() {
      if ($(window).scrollTop() >= 500 ) {
          banner.fadeIn();
      } else {
          banner.hide();     
      }
    
  });
});

